import { useGetXMLBlob } from '@/context/services/invoice/ReceivedInvoice.service';
import { useDownloadClick } from '@/features/invoices/components/Details/Components/Left/hooks';
import { useGetFlags } from '@/hooks/useFeatureFlag';
import { useTranslation } from '@/i18n';
import {
  ActionMenu,
  ActionMenuItems,
  ButtonV2Props,
  IconTrailing,
} from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { FC, memo, useMemo } from 'react';
import styles from './FileDownloadDropdown.module.scss';
import { useItems } from './hook';

const cx = classNames.bind(styles);

type InvoiceDownloadButtonProps = {
  onDownloadPDF: VoidFunction;
  fileName: string | undefined;
  invoiceId: string | undefined;
};
export const FileDownloadDropdown: FC<InvoiceDownloadButtonProps> = memo(
  ({ fileName: _fileName, onDownloadPDF, invoiceId }) => {
    const { t } = useTranslation();
    const { downloadBlob } = useGetXMLBlob(invoiceId);
    const fileName = _fileName?.replace(/\.pdf$/, '.xml');
    const onDownloadXML = useDownloadClick(
      downloadBlob,
      fileName ?? 'unknown.xml'
    );

    const flagEdocMetadata = useGetFlags('E_DOC_METADATA');

    const items: ActionMenuItems = useItems({
      onPDFClick: onDownloadPDF,
      onXMLClick: onDownloadXML,
    });

    const buttonProps: ButtonV2Props = useMemo(
      () => ({
        children: t('ダウンロード'),
        isSecondary: !flagEdocMetadata,
        isTertiary: !flagEdocMetadata,
        rightIcon: <IconTrailing size={16} />,
        containerClassName: cx({
          [styles['black-button']]: flagEdocMetadata,
        }),
      }),
      [t, flagEdocMetadata]
    );
    return <ActionMenu type='button' items={items} buttonProps={buttonProps} />;
  }
);
FileDownloadDropdown.displayName = 'FileDownloadDropdown';
